import { render, staticRenderFns } from "./ListParcoursclinique.vue?vue&type=template&id=0fe99731&"
import script from "./ListParcoursclinique.vue?vue&type=script&lang=js&"
export * from "./ListParcoursclinique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports